module.exports = __webpack_public_path__ + "static/media/blackjack-vector.19aba766.svg";